import { render } from "./BattlesGameOverViewBoxes.vue?vue&type=template&id=1aaf75b8&scoped=true"
import script from "./BattlesGameOverViewBoxes.vue?vue&type=script&lang=js"
export * from "./BattlesGameOverViewBoxes.vue?vue&type=script&lang=js"

import "./BattlesGameOverViewBoxes.vue?vue&type=style&index=0&id=1aaf75b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf75b8"]])

export default __exports__